module.exports = __webpack_public_path__ + "img/database.54a2382d.svg";